/**
 * Cryptographic randomness (Web Crypto) for retry jitter and non-guessable IDs.
 * Avoids `Math.random` (Sonar S2245 / pseudorandom unsuitable for security).
 */

const UINT32_RANGE = 4294967296; // 2**32 (avoids inconsistent hex separators for linters)

/** Uniform value in [0, 1) from 32 bits; 0 if `crypto.getRandomValues` is unavailable. */
export function randomUnit01(): number {
  const c = globalThis.crypto;
  if (typeof c?.getRandomValues !== 'function') return 0;
  const buf = new Uint32Array(1);
  c.getRandomValues(buf);
  return buf[0] / UINT32_RANGE;
}

